import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class UtilsService {

  constructor() { }

  getDateFromTime(time: any) {
    const date = new Date();
    date.setHours(time.hours);
    date.setMinutes(time.minutes);
    return date;
  }

  getHMfromMinutes(minutes) {
    return moment.utc().startOf('day').add(minutes, 'minutes').format('HH:mm');
  }

  getHrsMinFromMinutes(minutes) {
    const hours = Math.floor( minutes / 60);
    const min = minutes % 60;
    return `${hours} hrs ${min} mins`;
  }

  getTimeFromMinutes(minutes) {
    const hours = Math.floor( minutes / 60);
    const min = minutes % 60;
    return {
      hours,
      minutes: min
    };
  }

  getHMfromTime(time) {
    return moment.utc().startOf('day').add(time.hours, 'hours').add(time.minutes, 'minutes').format('hh:mm a');
  }

  getTimeDifferenceInMins(time1, time2) {
    return time1.hours * 60 + time1.minutes - time2.hours * 60 - time2.minutes;
  }

  stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }

  getInterpolatedColor(colorA, colorB, steps, stepNum) {

    colorA = this.hexToRgb(colorA); // [r,g,b]
    colorB = this.hexToRgb(colorB); // [r,g,b]
    const rStep = ( Math.max(colorA[0], colorB[0]) - Math.min(colorA[0], colorB[0]) ) / steps;
    const gStep = ( Math.max(colorA[1], colorB[1]) - Math.min(colorA[1], colorB[1]) ) / steps;
    const bStep = ( Math.max(colorA[2], colorB[2]) - Math.min(colorA[2], colorB[2]) ) / steps;
    const r = (colorA[0] < colorB[0]) ? colorA[0] + Math.round(rStep * stepNum) : colorA[0] - Math.round(rStep * stepNum);
    const g = (colorA[1] < colorB[1]) ? colorA[1] + Math.round(gStep * stepNum) : colorA[1] - Math.round(gStep * stepNum);
    const b = (colorA[2] < colorB[2]) ? colorA[2] + Math.round(bStep * stepNum) : colorA[2] - Math.round(bStep * stepNum);

    return this.rgbToHex([r, g, b]);
  }

  private hexToRgb(hex) {
    let r, g, b;
    // Remove the hash if given
    hex = hex.replace('#', '');
    // If invalid code given return white
    if (hex.length !== 3 && hex.length !== 6){
      return [255, 255, 255];
    }
    // Double up charaters if only three suplied
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    // Convert to [r,g,b] array
    r = parseInt(hex.substr(0, 2), 16);
    g = parseInt(hex.substr(2, 2), 16);
    b = parseInt(hex.substr(4, 2), 16);

    return [r, g, b];
  }

  private rgbToHex(color) {
    // Set boundries of upper 255 and lower 0
    color[0] = (color[0] > 255) ? 255 : (color[0] < 0) ? 0 : color[0];
    color[1] = (color[1] > 255) ? 255 : (color[1] < 0) ? 0 : color[1];
    color[2] = (color[2] > 255) ? 255 : (color[2] < 0) ? 0 : color[2];

    const res = this.zeroFill(color[0].toString(16), 2) + this.zeroFill(color[1].toString(16), 2) + this.zeroFill(color[2].toString(16), 2);

    return '#' + res;
  }

  private zeroFill(number, width ){
    width -= number.toString().length;
    if ( width > 0 ) {
      return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
    }
    return number;
  }


}



// WEBPACK FOOTER //
// ./client/app/core/utils/utils.service.ts